import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import configureStore from './redux/store';
import configureApolloClient from './apollo/client';
import Root from './Root';
import AbacusClientUtils from '@homeaway/abacus-client-utils';
import { initLypOnClick } from './indexListYourProperty';
import { initializeTrackFocus } from './utils/a11ySupport';

/**
 * Main client-side entry point. This is not used during
 * server-side rendering, only after the javascript bundle
 * has been loaded into the browser.
 */
const initialState = window.__INITIAL_STATE__;
const { system: { urlPrefix }} = initialState;

if (!module.hot) {
  // eslint-disable-next-line camelcase, no-undef
  __webpack_public_path__ = window.__webpack_public_path__;
}

const store = configureStore(initialState);
const client = configureApolloClient(urlPrefix);

const abacusExperiments = store.getState().abacus.experiments;
AbacusClientUtils.initialize(abacusExperiments);

ReactDOM.hydrate(
  <ApolloProvider client={client}>
    <Root
      store={store}
      siteContext={window.__SITE_CONTEXT__}
    />
  </ApolloProvider>,
  document.getElementById('root')
);

initializeTrackFocus();
initLypOnClick();
